<template>
  <USlideover v-model="isOpen" class="!p-0">
    <div class="flex flex-col h-screen bg-white">
      <!-- Header -->
      <div class="flex items-center justify-between p-4 border-b">
        <button
          v-if="currentPath.length > 0"
          @click="goBack"
          class="flex items-center text-slate-600 hover:text-orange-500 transition-colors"
        >
          <UIcon name="i-heroicons-arrow-left" class="w-5 h-5 mr-2" />
          <span class="text-sm font-medium">Geri</span>
        </button>
        <h3 class="text-lg font-medium text-slate-800">
          {{ getCurrentTitle }}
        </h3>
        <button
          @click="closeMenu"
          class="text-slate-400 hover:text-slate-600 transition-colors"
        >
          <UIcon name="i-heroicons-x-mark" class="w-6 h-6" />
        </button>
      </div>

      <!-- Menu Content -->
      <div class="flex-1 overflow-y-auto">
        <ul class="divide-y divide-slate-100">
          <li v-for="item in currentItems" :key="item.id">
            <div
              class="flex items-center justify-between p-4 hover:bg-slate-50 transition-colors"
            >
              <NuxtLink
                :to="`/katalog/${item.slug}-c${item.id}`"
                class="flex-1 text-slate-700 hover:text-orange-500 transition-colors"
                @click="closeMenu"
              >
                {{ item.name }}
              </NuxtLink>
              <button
                v-if="hasChildren(item)"
                @click="navigateToChildren(item)"
                class="p-2 text-slate-400 hover:text-orange-500 transition-colors"
              >
                <UIcon name="i-heroicons-chevron-right" class="w-5 h-5" />
              </button>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </USlideover>
</template>

<script setup>
const props = defineProps({
  menu: {
    type: Array,
    required: true
  }
})

const isOpen = defineModel('isOpen')

// Menü navigasyon state'i
const currentPath = ref([])
const currentItems = ref([])

// Başlangıçta ana menüyü göster
watchEffect(() => {
  if (isOpen.value) {
    currentItems.value = props.menu
    currentPath.value = []
  }
})

// History API için event listener
onMounted(() => {
  window.addEventListener('popstate', handlePopState, { passive: true })
})

onUnmounted(() => {
  window.removeEventListener('popstate', handlePopState)
})

// Geri tuşu yönetimi
const handlePopState = (event) => {
  if (isOpen.value) {
    if (currentPath.value.length > 0) {
      // Alt kategorideyse bir üst kategoriye dön
      goBack()
    } else {
      // Ana menüdeyse menüyü kapat
      closeMenu()
    }
  }
}

// Mevcut başlığı hesapla
const getCurrentTitle = computed(() => {
  if (currentPath.value.length === 0) return 'Kategoriler'
  return currentPath.value[currentPath.value.length - 1].name
})

// Alt öğeleri olan kategorileri kontrol et
const hasChildren = (item) => {
  return item.children && Object.keys(item.children).length > 0
}

// Alt kategorilere git
const navigateToChildren = (item) => {
  currentPath.value.push(item)
  currentItems.value = Object.values(item.children)
}

// Bir seviye geri git
const goBack = () => {
  currentPath.value.pop()
  if (currentPath.value.length === 0) {
    currentItems.value = props.menu
  } else {
    const lastItem = currentPath.value[currentPath.value.length - 1]
    currentItems.value = Object.values(lastItem.children)
  }
}

// Menüyü kapat
const closeMenu = () => {
  isOpen.value = false
  // Menü kapandığında state'i sıfırla
  setTimeout(() => {
    currentPath.value = []
    currentItems.value = props.menu
  }, 300)
}
</script>
